// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-panel>.md-toolbar .md-title{color:#555!important}.main-panel>#sticky-toolbar{position:sticky;top:0;opacity:.9;background-color:#eee!important}", ""]);
// Exports
module.exports = exports;
